
import {GRAMS_PER_POUND} from 'constants/units';
import {ArrowColor} from 'templates/reports/_shared/Arrow';
import {Summary} from 'templates/reports/query';

export type Column = {
	title: string
	val?: (v: Summary) => number
	fmt?: (v: number) => string
	str?: (v: Summary) => string
	arrow?: ArrowColor
	neutral?: boolean
}

const fmtPounds = (grams: number) => (
	`${(grams / GRAMS_PER_POUND).toFixed(1)} lbs`
);

export const columns: Column[] = [
	{
		title: 'Measure time',
		str: (v) => v.start.full,
	},
	{
		title: 'Fat %',
		val: (v) => v.fat / (v.fat + v.lean + v.bone),
		fmt: (v) => `${(v * 100).toFixed(1)}%`,
		arrow: 'standard',
	},
	{
		title: 'Total mass',
		val: (v) => v.fat + v.lean + v.bone,
		fmt: fmtPounds,
		arrow: 'neutral',
	},
	{
		title: 'Fat mass',
		val: (v) => v.fat,
		fmt: fmtPounds,
		arrow: 'standard',
	},
	{
		title: 'Lean mass',
		val: (v) => v.lean,
		fmt: fmtPounds,
		arrow: 'reverse',
	},
	{
		title: 'Bone mass',
		val: (v) => v.bone,
		fmt: fmtPounds,
	},
];
